import routerOptions0 from "/src/app/router.options.ts";
import routerOptions1 from "/src/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}